































import { Vue, Component, Prop } from 'vue-property-decorator';

const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';
import { Snotify } from '@/snotify/Snotify';

import { fetchMS } from '@/pantallas/Conecta/BajasCobranza/fetchMS';

@Component({ components: { GridComponent: AgGridVue } })
export default class TabDispositivos extends Vue {
  @Prop({ required: true, default: '' }) id!: string;

  columnApi: ColumnApi = null;
  gridOptions: GridOptions = null;
  gridEvent: GridReadyEvent = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  quickSearch: string = '';
  serverSide: any = null;

  readonly $snotify: Snotify = null;

  constructor() {
    super();
    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 4,
      cacheBlockSize: 4,
      overlayNoRowsTemplate: 'No hay datos disponibles para mostrar',
      onGridReady: this.handleMainGridReady,
      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
    };
  }

  async handleMainGridReady(event: GridReadyEvent): Promise<void> {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    const self = this;
    this.serverSide = {
      async getRows(event: any): Promise<void> {
        event.request.paginationSize = self.gridOptions.cacheBlockSize;
        const body = {
          id: Number(self.id),
          quick_search: self.quickSearch || '',
          ...event.request,
        };
        try {
          const response = await fetchMS({
            endpoint: 'get_bajas_child',
            body,
          });
          const {
            MENSAJE_RESPUESTA,
            CODIGO_RESPUESTA,
            LISTA,
            TOTAL,
          } = response.data;
          const cod: number = Number(CODIGO_RESPUESTA);
          if (cod !== 1) {
            event.successCallback([], 0);
            self.gridApi.showNoRowsOverlay();
            MENSAJE_RESPUESTA !== 'SIN_DATA' &&
              self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
            return;
          }
          event.successCallback(LISTA, TOTAL);
        } catch (error) {
          console.error(error instanceof Error ? error.message : error);
          self.$snotify.error(
            'Ha ocurrido un error inesperado, por favor reintente un poco más tarde',
            { timeout: 3500 }
          );
        }
      },
    };
    this.reloadGrid();
  }

  async reloadGrid() {
    setTimeout(() => {
      this.gridApi.setServerSideDatasource(this.serverSide);
      this.gridApi.setDomLayout('autoHeight');
    }, 0);
  }

  private colsGrid(): ColDef[] {
    const cols = [
      { id: 'serienumero', field: 'Serie Número' },
      { id: 'nombre_epc', field: 'Nombre EPC' },
      { id: 'estado_coenecta', field: 'Estado Conecta' },
      { id: 'fecha_creacion', field: 'Fecha Creación' },
      { id: 'fecha_instalacion', field: 'Fecha Instalación' },
      { id: 'tecnico_instalador', field: 'Tecnico' },
      { id: 'patente', field: 'Patente' },
      { id: 'tipo_instalacion', field: 'Tipo Instalación' },
      { id: 'cliente_nombre', field: 'Nombre Cliente' },
      { id: 'nota_venta', field: 'Nota de Venta' },
      { id: 'flota', field: 'Flota' },
      { id: 'serie_simcard', field: 'Serie SIM' },
      { id: 'movil', field: 'Movil' },
      { id: 'nombre_producto', field: 'Nombre Producto' },
      { id: 'caso_crm_desinstalacion', field: 'Caso Desinstalación CRM' },
    ];

    return cols.map(col => ({
      headerName: col.field,
      field: col.id,
      cellStyle: { textAlign: 'left' },
      resizable: true,
      width: 220,
      minWidth: 100,
    }));
  }
}
